<template>
  <div class="ui-nio-modal">
    <van-popup v-model="showModal"
               position="bottom"
               :close-on-click-overlay="clickOverlay"
               @close="handleClose">
      <slot>
        <div class="ui-nio-modal__content">
          <div v-for="(option, i) in options"
               :key="i"
               class="ui-nio-modal__item"
               @click="handleSelected(option)">
            {{ option.label }}
          </div>
        </div>
      </slot>
      <nio-button type="btn_outline_l"
                  class="ui-nio-modal__cancel-btn"
                  @click="handleClose">
        {{ $t('content.commonCancelText') }}
      </nio-button>
    </van-popup>
  </div>
</template>

<script>
/*
 * nio modal 模态框
 * 默认可通过options配置渲染生成选择列表样式的弹框
 * 也支持自定义主体部分
 *
 * events:
 *  change({optionsItem})
 *  close
 *
 * e.g
 * <nio-modal :visible.sync="showShareModal" :options="[{label: 'share', value: 'share'}]" @change="onSelectChange"></nio-modal>
 */
import Vue from 'vue';
import {Popup} from 'vant';
import NioButton from './NioButton';

Vue.use(Popup);
export default {
  name: 'NioModal',
  components: {
    NioButton
  },
  props: {
    // 弹框显示隐藏
    visible: {
      type: Boolean,
      default: false
    },
    // 弹框主体列表项配置
    options: {
      type: Array,
      default: () => []
    },
    // 点击空白区域是否关闭弹框
    clickOverlay: {
      type: Boolean,
      default: true
    }
  },
  data(){
    return {
      showModal: this.visible
    };
  },
  mounted(){
  },
  watch: {
    visible(newVal){
      if (newVal !== this.showModal){
        this.showModal = newVal;
      }
    }
  },
  methods: {
    handleSelected(option){
      this.$emit('change', option);
      this.handleClose();
    },
    handleClose(){
      this.showModal = false;
      this.$emit('update:visible', false);
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/standard";
@import "../../assets/scss/mixins";

.ui-nio-modal {
  &__content {
    @include pagePadding();
  }

  &__item {
    height: sizeTrans(60);
    line-height: sizeTrans(60);
    font-size: sizeTrans(16);
    color: $color_mb1_front;
    text-align: center;
    @include ellipsis();
  }

  &__cancel-btn {
    margin: sizeTrans($space_15) sizeTrans($space_20) sizeTrans(50);
  }
}
</style>